'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var nthHookTheme = require('@narvar/nth-hook-theme');
var Label_module = require('./Label.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

let LabelVerticalAlign = /*#__PURE__*/function (LabelVerticalAlign) {
  LabelVerticalAlign["top"] = "TOP";
  LabelVerticalAlign["middle"] = "MIDDLE";
  return LabelVerticalAlign;
}({});
let LabelAnimateState = /*#__PURE__*/function (LabelAnimateState) {
  LabelAnimateState["none"] = "NONE";
  LabelAnimateState["inactive"] = "INACTIVE";
  LabelAnimateState["active"] = "ACTIVE";
  return LabelAnimateState;
}({});
const DEFAULT_FONTSIZE_REM = '0.875'; // 14px
const SCALED_FONTSIZE_REM = '0.75'; // 12px
const LABEL_SCALE_STR = `${SCALED_FONTSIZE_REM}/${DEFAULT_FONTSIZE_REM}`;
const Label = ({
  children,
  disabled = false,
  centered = false,
  verticalAlign = LabelVerticalAlign.top,
  labelState = LabelAnimateState.none,
  htmlFor
}) => {
  const {
    inputlabelNoneDisabled: labelStyleDisabled,
    inputlabelNoneNone: labelStyle
  } = nthHookTheme.useTheme();
  const isLabelDisabled = disabled && labelState === LabelAnimateState.none;
  const isAnimation = labelState !== LabelAnimateState.none;
  const customLabelStyle = isLabelDisabled ? labelStyleDisabled : labelStyle;
  const classes = clsx__default["default"]({
    [Label_module["default"].label]: true,
    [Label_module["default"].transition]: isAnimation,
    [Label_module["default"].verticalTop]: verticalAlign === LabelVerticalAlign.top,
    [Label_module["default"].verticalMiddle]: verticalAlign === LabelVerticalAlign.middle,
    [Label_module["default"].centered]: centered && isAnimation,
    [Label_module["default"].labelDisabled]: isLabelDisabled
  });
  const labelStateStyles = labelState === LabelAnimateState.active ? {
    top: '0.25rem',
    // This doesn't change for vertical top aligned, but needs to be set for middle aligned
    transform: centered ? `translate3d(-50%, 0, 0) scale(calc(${LABEL_SCALE_STR}))` : `translate3d(0, 0, 0) scale(calc(${LABEL_SCALE_STR}))`
  } : {};
  const style = {
    fontSize: `${DEFAULT_FONTSIZE_REM}rem`,
    ...customLabelStyle,
    ...labelStateStyles
  };
  return /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: htmlFor,
    className: classes,
    style: style
  }, children);
};
var Label$1 = nthHookTheme.withThemeProvider(Label, {
  themeTokens: ['inputlabelNoneDisabled', 'inputlabelNoneNone']
});

exports.LABEL_SCALE_STR = LABEL_SCALE_STR;
exports.LabelAnimateState = LabelAnimateState;
exports.LabelVerticalAlign = LabelVerticalAlign;
exports["default"] = Label$1;
